import React, { useState } from "react";
import { trackError } from "../../../../lib/metrics";

export default function LaptopUnlock({
  onUnlock,
  pseudo = "Joueur",
  missionUnlock,
  missionResolve,
  sessionCode,
  stage = 2,
  playerId,
}) {
  const [password, setPassword] = useState("");
  const [error, setError] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (password.toUpperCase() === "NEURAL") {
      missionResolve?.({ key: "s2.p5.laptop.found" });
      missionResolve?.({ key: "s2.p2.password.found" });
      onUnlock();
    } else {
      setError(true);
      trackError({ sessionCode, stage, playerId, reason: "s2.laptop.wrong_password" });
      setTimeout(() => { setError(false); }, 500);
      setPassword("");
    }
  };

  return (
    <div className="flex items-center justify-center h-[75vh] bg-gradient-to-br from-slate-950 via-slate-900 to-slate-950 rounded-xl border border-slate-700">
      <div className={`w-[400px] p-8 bg-slate-900/60 border border-slate-700 rounded-2xl shadow-2xl ${error ? "animate-[shake_0.3s_ease]" : ""}`}>
        <div className="flex flex-col items-center mb-6">
          <div className="w-24 h-24 bg-gradient-to-br from-emerald-500 to-teal-500 rounded-full flex items-center justify-center text-4xl mb-3 shadow-lg">
            👤
          </div>
          <div className="text-white font-semibold">Utilisateur</div>
          <div className="text-xs text-slate-400">ORIGAMI OS</div>
        </div>

        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <label className="block text-xs text-slate-400 mb-2">Mot de passe</label>
            <input
              type="password"
              value={password}
              onChange={(e) => { setPassword(e.target.value); setError(false); }}
              className={`w-full px-4 py-3 bg-slate-950/60 border ${error ? "border-red-500" : "border-slate-700"} rounded-lg text-white focus:outline-none focus:ring-2 focus:ring-emerald-500 transition`}
              placeholder="••••••••"
              autoFocus
            />
            {error && <div className="text-xs text-red-400 mt-2">Mot de passe incorrect</div>}
          </div>

          <button
            type="submit"
            className="w-full py-3 bg-gradient-to-r from-emerald-600 to-teal-600 hover:from-emerald-500 hover:to-teal-500 text-white font-semibold rounded-lg transition shadow-lg"
          >
            Déverrouiller
          </button>
        </form>

        <div className="mt-4 text-center text-xs text-slate-500">Propriété de ORIGAMI Corp.</div>
      </div>

      <style>{`
        @keyframes shake {
          0%, 100% { transform: translateX(0); }
          25% { transform: translateX(-10px); }
          75% { transform: translateX(10px); }
        }
      `}</style>
    </div>
  );
}